import React from 'react'

const FilterResultsViewButtons = ({changeView, hasShowtimesFeature, activeView, hasGridTrailerFeature}) => {
    const gridActive = activeView === 'grid' ? ' active' : ''
    const listActive = activeView === 'list' ? ' active' : ''
    const trailerActive = activeView === 'grid-trailer' ? ' active' : ''
    const showtimesActive = activeView === 'showtimes' ? ' active' : ''

    return (
    <div className="overview-view-button-wrapper">
        <button className={"overview-view-button overview-view-button-grid cursor-pointer" + gridActive} onClick={() => changeView({view: 'grid'})}>
            <div>
                <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <path className="cls-1" d="M0,0H0V21.51H21.51V0H0ZM18.51,18.51H3V3H18.51Z" transform="translate(0 0)"/>
                    <path className="cls-1" d="M28.49,0h0V21.51H50V0H28.49ZM47,18.51H31.49V3H47Z" transform="translate(0 0)"/>
                    <path className="cls-1" d="M28.49,28.49h0V50H50V28.49H28.49ZM47,47H31.49V31.49H47Z" transform="translate(0 0)"/>
                    <path className="cls-1" d="M0,28.49H0V50H21.51V28.49H0ZM18.51,47H3V31.49H18.51Z" transform="translate(0 0)"/>
                </svg>
            </div>
            <span className="screen-reader-text">Grid</span>
        </button>

        {hasGridTrailerFeature &&  <button className={"overview-view-button overview-view-button-grid-trailer cursor-pointer" + trailerActive} onClick={() => changeView({view: 'grid-trailer'})}>
            <div>
                <svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <g id="Ebene_1-2">
                        <g id="Ebene_1-3">
                            <path className="cls-1" d="M0,0H0V50H50V0H0ZM47,47H3V3H47V47Zm-31.38-8.64V11.64l23.14,13.36-23.14,13.36Zm3.33-20.95v15.18l13.15-7.59-13.15-7.59Z"/>
                        </g>
                    </g>
                </svg>
            </div>
            <span className="screen-reader-text">Grid Trailer</span>
        </button>}

        <button className={"overview-view-button overview-view-button-list cursor-pointer" + listActive} onClick={() => changeView({view: 'list'})}>
            <div>
            <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50.03">
                <path className="cls-1" d="M0,0H0V13.77H13.75V0H0ZM10.75,10.77H3V3h7.75Z"/>
                <path className="cls-1" d="M0,18.13V31.9H13.75V18.13ZM10.75,28.9H3V21.15h7.75Z"/>
                <path className="cls-1" d="M0,36.26V50H13.75V36.26ZM10.75,47H3V39.28h7.75Z"/>
                <path className="cls-1" d="M18.13,0h0V13.77H50V0H18.13ZM47,10.77H21.13V3H47Z"/>
                <path className="cls-1" d="M18.13,18.13V31.9H50V18.13ZM47,28.9H21.13V21.15H47Z"/>
                <path className="cls-1" d="M18.13,36.26V50H50V36.26ZM47,47H21.13V39.28H47Z"/>
            </svg>
            </div>
            <span className="screen-reader-text">List</span>
        </button>

        {hasShowtimesFeature && <button className={"overview-view-button overview-view-button-showtimes cursor-pointer" + showtimesActive} onClick={() => changeView({view: 'showtimes'})}>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <g id="a"/>
                    <g id="b">
                        <g id="c">
                            <path className="d" d="M0,0H0V50H50V0H0ZM47,47H3V3H47V47Z"/>
                            <rect className="d" x="1.36" y="11.98" width="46.55" height="3"/>
                            <g>
                                <rect className="d" x="7.8" y="19.59" width="13.31" height="3"/>
                                <rect className="d" x="7.8" y="29.47" width="13.31" height="3"/>
                                <rect className="d" x="7.8" y="39.35" width="13.31" height="3"/>
                            </g>
                            <g>
                                <rect className="d" x="28.26" y="19.59" width="13.31" height="3"/>
                                <rect className="d" x="28.26" y="29.47" width="13.31" height="3"/>
                                <rect className="d" x="28.26" y="39.35" width="13.31" height="3"/>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <span className="screen-reader-text">Showtimes</span>
        </button>}
    </div>
)}

export default FilterResultsViewButtons